import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

import Key from './Key';

const KeyItemStyled = styled.li`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    ${Key} {
        font-weight: 600;
        font-family: Favorit;
        margin-right: 10px;
    }
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('KeyValuePairsItem.styes')}
`;

export default KeyItemStyled;
